module.exports = __webpack_public_path__ + "static/media/hiw-kitchen-bg@sm.e6b88b11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awair/hiw-kitchen-bg@sm.jpg
// module id = 211
// module chunks = 0